var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'logo-container ' + _vm.size},[_c('img',{ref:"logoImage",staticClass:"transparent mx-auto",attrs:{"src":_vm.src}}),(!_vm.custom && _vm.showSlogan)?_c('span',{staticClass:"mx-2",attrs:{"id":"logo-text"}},[_c('span',{attrs:{"id":"logo-text-name"}},[_vm._v("SwitchQ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }